module.exports = __webpack_public_path__ + "static/media/VirtualPBX12.fbd1642a.JPG";